<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="单计量单位组"
      edit-title
      id-key="UnitId"
      form-label-width="120px"
      :data="data"
      :line-form="true"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      close-on-saved
      @close-saved="onClosed"
    >
      <template slot="form">
        <el-form-item label="计量单位编码" prop="UnitNo">
          <span v-if="Mode == 0" class="detail-span">{{ data.UnitNo }}</span>
          <el-input
            v-else
            v-model="data.UnitNo"
            placeholder="请输入计量单位编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="计量单位名称" prop="UnitName">
          <el-input
            v-model="data.UnitName"
            placeholder="请输入计量单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input
            v-int
            type="number"
            v-model="data.Sn"
            style="width: 100px"
          ></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/ba/unit").default,
      data: {
        UnitId: 0,
        UnitNo: "",
        UnitName: "",
        Status: 1,
        Sn:null,
        IsGroup: false,
        IsSingleUnit: true,
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      rules: {
        UnitNo: [{ required: true, message: "类别编号不能为空" }],
        UnitName: [{ required: true, message: "名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    serialCode() {
      this.code_api.previewNo("计量单位").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.UnitNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取计量单位编号失败");
        }
      });
    },
    onCreateOpened() {
      console.log('创建');
      this.api.getMaxSn({}).then((res) => {
        this.data.Sn = res;
      });
      this.serialCode();
      // this.api.getMaxSn(this.data.ClassType, this.data.Pid).then((res) => {
      //   this.data.Sn = res;
      // });
      // this.code_api.previewNo("颜色类别").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.UnitNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取颜色类别编号失败");
      //   }
      // });
    },
    onClosed() {
      this.$emit("close-saved");
    },
  },
};
</script>
